import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { externalDial, externalHangup } from "../../../utilities/vicidial/save";
import TelefonoAdd from "./TelefonoAdd";
import apiInstance from "../../../services/ServiceApi";
import { Message } from "@mui/icons-material";
import PhoneIcon from '@mui/icons-material/Phone';
import ModalEnviarMensaje from "../../sms/SendSMS";

const TelefonosPorPagina = 5;

const TelefonoListado = ({ telefonos: telefonosIniciales ,codigo_usuario ,cliente_id, lineaNegocio }) => {
  const [pagina, setPagina] = useState(1);
  const [selectedPhone, setSelectedPhone] = useState(null);
  const [clickState, setClickState] = useState(null);  // track click state
  const [modalOpen, setModalOpen] = useState(false);
  const [telefonos, setTelefonos] = useState(telefonosIniciales);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [telefonoSeleccionado, setTelefonoSeleccionado] = useState(false);
  const handleSMSClick = async (telefono) => {
    setModalAbierto(true);
    setTelefonoSeleccionado(telefono);
  }
  const handlePhoneClick = async (telefono) => {
    if (telefono === selectedPhone && clickState === 'dial') {
      setClickState('hangup');
      const hangupResult = await externalHangup({ 
        agentId: codigo_usuario, 
        value: telefono.telefono
      });
      if (hangupResult) {
        console.log("hangup a",telefono)
      } else {
        alert('Error updating status');
      }
    } else {
      setSelectedPhone(telefono);
      setClickState('dial');
      const dialResult = await externalDial({ 
        agentId: codigo_usuario, 
        phoneNumber: telefono.telefono
      });
      if (dialResult) {
        console.log("call to",telefono)

      } else {
        alert('Error making call');
      }
    }
  };
  const cargarTelefonos = async () => {
    try {
      const response = await apiInstance.get('/telefono/', {
        params: { cliente: cliente_id } 
      });
      setTelefonos(response.data);
    } catch (error) {
      console.error('Error al cargar los teléfonos:', error);
    }
  };

  const handleTelefonoAgregado = () => {
    cargarTelefonos();
  };
  

  const handleChangePage = (event, value) => {
    setPagina(value);
  };

  const telefonosMostrados = telefonos.slice(
    (pagina - 1) * TelefonosPorPagina,
    pagina * TelefonosPorPagina
  );

  return (
    <>
    {modalAbierto && (
        <ModalEnviarMensaje
          telefono={telefonoSeleccionado.telefono }
          cliente_id= {cliente_id}
          onClose={() => setModalAbierto(false)}
        />
      )}
    
    <Card elevation={3}>
      <Box position="relative">
        <Box position="absolute" top={0} left={0} bgcolor="green" color="white" py={0.5} px={2}>
          <Typography variant="button">Teléfonos</Typography>
        </Box>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" style={{visibility: 'hidden'}}>Teléfonos</Typography>
            <TelefonoAdd
                open={modalOpen}
                onClose={()=>setModalOpen(false)}
                cliente={cliente_id}
                onTelefonoAgregado={handleTelefonoAgregado}
              />
          </Box>
          <Table size="small">
            <TableHead>
              <TableRow >
                <TableCell sx={{ paddingRight: 1 }}><Typography variant="subtitle2">Teléfono</Typography></TableCell>
                <TableCell><Typography variant="subtitle2">Acción</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {telefonosMostrados.map((telefono, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography variant="body2">{telefono.telefono}</Typography>
                  </TableCell>
                  <TableCell>
                    <PhoneIcon onClick={() => handlePhoneClick(telefono)} fontSize="small" color={telefono === selectedPhone ? 
                      (clickState === 'dial' ? "success" : "error") : "primary"} sx={{'paddingRight':'6px'}}/>
                      {lineaNegocio.sent_sms &&
                        <Message onClick={() => handleSMSClick(telefono)} fontSize="small" color="primary" />
                      }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Pagination
            count={Math.ceil(telefonos.length / TelefonosPorPagina)}
            page={pagina}
            onChange={handleChangePage}
            color="primary"
            size="small"
            sx={{ mt: 1, display: "flex", justifyContent: "center" }}
          />
        </CardContent>
      </Box>
      
    </Card>
    </>

  );
};

export default TelefonoListado;